import React from 'react';
import SelectReact from 'react-select';
import './style.scss';

export const Select = ({ options, onChange, disabled, ...props }) => (
  <SelectReact classNamePrefix="custom-select" options={options} isDisabled={disabled} onChange={onChange} {...props} />
);
